import { SUNDAY_OFFERS } from 'Constants/Shop';
import DateHelper from 'Utility/DateHelper';
import { ISundayOfferData } from './ISundayOfferData';
import { AssertionError } from "assert";
import { PopupOffersOfType, PopupOfferType, PopupOfferTypeMap } from './PopupOffers';
import { cached } from 'Utility/async';
import Game from 'Game';
import { IAPReward } from 'Utility/RewardHelper';

const EPOCH_FIRST_SUNDAY_OFFSET = 345_600_000;
const PAYER_REACTIVATION_OFFER_KEYS = Object.keys(PopupOfferTypeMap[PopupOfferType.PAYER_REACTIVATION_OFFER]);

export namespace IAPHelper {
    export function getWeeklySundayOfferData(): ISundayOfferData {
        const weekNumber = DateHelper.weeksSinceEpoch(DateHelper.now, EPOCH_FIRST_SUNDAY_OFFSET);
        const offers = Object.values<ISundayOfferData>(SUNDAY_OFFERS);
        const offerIndex = weekNumber % offers.length;
        return offers[offerIndex];
    }
    
    export function isValidPayerReactivationOffer(val: any): asserts val is keyof PopupOffersOfType<PopupOfferType.PAYER_REACTIVATION_OFFER> {
        //If key exists assert type else throw error
        if (!PAYER_REACTIVATION_OFFER_KEYS.includes(val)) {
            throw new AssertionError({message: "Not a valid PayerReactivationOffer"});
        }
    }
    
    export const CACHED_IAP_REWARDS_MAP = cached(() => {
        return Object.fromEntries(Game.resource.get<IAPReward[]>('IAPRewards').map(r => [r.id, r]));
    })
}
